import styled from 'styled-components'

export const Mensagem = styled.span`
  display: block;
  margin-top: 0.6vh;
  padding-left: 1vw;
  font-size: 0.8rem;
  color: #d93025;
`
